import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthComponent } from './auth.component';
import { AuthRoutingModule } from './auth-routing.module';
import { ThemeModule } from './../@theme/theme.module';
import { LoginComponent } from './login/login.component';
import { NbButtonModule, NbCardModule, NbCheckboxModule, NbIconModule, NbInputModule, NbLayoutModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NbAuthModule } from '@nebular/auth';
import { NgxMaskModule } from 'ngx-mask';
import { DialogForgotPasswordComponent } from './login/dialog-forgot-password/dialog-forgot-password.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  imports: [
    AuthRoutingModule,
    CommonModule,
    ThemeModule,
    FormsModule,
    RouterModule,
    NbLayoutModule,
    NbInputModule,
    NbButtonModule,
    NbCheckboxModule,
    NbIconModule,
    NbCardModule,
    NbAuthModule,
    NgxMaskModule.forRoot(),
    ProgressSpinnerModule
  ],
  declarations: [
    AuthComponent,
    LoginComponent,
    DialogForgotPasswordComponent,
  ],
})
export class AuthModule { }
